import { Component, OnInit, SecurityContext } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ContractTermsAgencyModel } from 'src/app/Model/ContractTermsAgency.model';
import { RequestModel } from 'src/app/Model/Request.model';
import { StatusChangeByComponentView } from 'src/app/Model/StatusChangeByComponentView.model';
import { VRequestStatusProcessModel } from 'src/app/Model/VRequestStatusProcess.Model';
import { SessionStorageService } from 'src/app/Services/sessionStorageService/session-storage.service';
import { RequesStatusService } from 'src/app/Services/RequestStatus/RequesStatus.service';
import { ComService } from 'src/app/Services/com-service/com.service';
import { ContractsService } from 'src/app/Services/contracts/contracts.service';
import { DocumentService } from 'src/app/Services/document/Documentservice';
import { MauroService } from 'src/app/Services/mauro/Mauroservice';
import { RequestService } from 'src/app/Services/request/request.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { ConsultConnectionDataComponent } from '../consult-connection-data/consult-connection-data.component';

@Component({
  selector: 'app-accept-terms',
  templateUrl: './accept-terms.component.html',
  styleUrls: ['./accept-terms.component.css']
})
export class AcceptTermsComponent implements OnInit {

  public Request: RequestModel;
  public requestcode: string;
  public type: string = null;
  public showButton: boolean;
  public ContractTermsAgency: ContractTermsAgencyModel
  public blobService;
  public ContractUrl: string
  public masterContainer = 'agency-documents'
  public blobPdf = new Blob()
  public blobUrl: any
  public Url;
  public checked : boolean;
  public formGroup: FormGroup;
  public ContractTermsBool: boolean;
  public isRejected : boolean;
  public lang : string;
  public activeLang = 'es';
  public buttonBool = false;
  public SabreAmadeusBool: boolean;
  public checkedWhenFirstIsChecked;
  lstStatuses: VRequestStatusProcessModel[]=[];
  allowEdit: boolean;
  AprovedFlowStateBool: boolean;
  ContractTermsBoolValidation: boolean
  constructor(
    private readonly Service: DocumentService,
    private readonly Service2: ContractsService,
    private readonly activeRoute: ActivatedRoute,
    private readonly translate: TranslateService,
    private readonly SpinnerService: NgxSpinnerService,
    private readonly DocumentService: DocumentService,
    protected sanitizer: DomSanitizer,
    private readonly router: Router,
    private readonly RequesStatus: RequesStatusService,
    private readonly Mauro: MauroService,
    private readonly dataService: ComService,
    private readonly modalService: NgbModal,
    private readonly requestService: RequestService,
    private readonly lsService : SessionStorageService
  ) {

  }

  form = new FormGroup({
    approveTermsLegal: new FormControl('', [Validators.required,])
  });

  async ngOnInit() {

    if (this.activeRoute.snapshot.params.requestcode == undefined) {
      this.requestcode = this.lsService.getLSItem("RequestCode");
    } else {
      this.requestcode = this.activeRoute.snapshot.params.requestcode;
    }

    if(this.lsService.getLSItem('language') == null){
      this.lang = this.activeLang
    }
    else{
      this.lang = this.lsService.getLSItem('language')
    }
    await this.GetRequestByCode()
    this.getUrlTyC()
  }

  public async getUrlTyC(){
    let id = this.Request.Id
    let rt = await this.Service2.getUrlTyC(id);
    if(rt == null){
      this.buttonBool = false
      Swal.fire({
        icon: "warning",
        title: this.translate.instant('AcceptTerms.Messages.0'),
        showConfirmButton: false,
        timer: 3000,
      }).then(async (result) => {
        window.location.replace(`Register/Main/ApplicationApproval`);
      });
    }
    else{
      this.buttonBool = true
      let encodedUrl = encodeURIComponent(rt)
      this.Url = `https://view.officeapps.live.com/op/embed.aspx?src=${encodedUrl}`

      let SafeUrl = this.sanitizer.sanitize(SecurityContext.URL, this.Url);
      this.Url = this.sanitizer.bypassSecurityTrustResourceUrl(SafeUrl);

    }
  }

  /**
   * getContractTermsAgencyByCode
   */
  public async getContractTermsAgencyByCode() {

    await this.Service.getContractTermsAgencyByCode(this.Request.RequestCode).then(
      async (res) => {

        this.ContractTermsAgency = res;

        if ((this.ContractTermsAgency != undefined ? this.ContractTermsAgency.Status : '') != 'Aproved' || this.ContractTermsBool == false) {
          
          this.SpinnerService.hide()

        } else {

          Swal.fire({
            icon: "warning",
            title: this.translate.instant('AcceptTerms.Messages.1'),
            showConfirmButton: false,
            timer: 3000,
          });

          if(this.ContractTermsAgency.Status == 'Aproved'){
            this.checkedWhenFirstIsChecked = true;
          }
          else{
            this.checkedWhenFirstIsChecked = false;
          }

          this.showButton = false
          this.SpinnerService.hide()

        }
      }
    );

  }



  public async GetRequestByCode() {

    if (this.requestcode != undefined) {

      this.SpinnerService.show()

      await this.Service.getRequestByCode(this.requestcode).then(
        async (res) => {

          this.Request = res;

          await this.getValidateTermsAndConditions(this.Request.Id)
          await this.getDocumentsApproval(this.Request.Id)

          //validar si puede estar en este sección
          if(!this.ContractTermsBool && !this.AprovedFlowStateBool){
            Swal.fire({
              icon: "error",
              title: this.translate.instant("Main.Flows"),
              showConfirmButton: false,
              showCloseButton: true,
              timer: 3000,
            }).then((res) => {
              window.location.replace(`Register/Main/Request`);
            })
          }

          this.lsService.setLSItem('RequestCode',this.Request.RequestCode)
          this.lsService.setLSItem('IdRequest',this.Request.Id.toString())
          this.lsService.setLSItem('type',this.Request.ConnectionType.toString())

          this.getContractTermsAgencyByCode();

          let id = parseInt(this.lsService.getLSItem("IdRequest"))
            this.lstStatuses=await this.requestService.getRequestStatuses(id)
            this.allowEdit = this.lstStatuses.some(x => x.IdComponent == 2)

            if(this.Request.AggregatorIdGeo == environment.request.idSabreColombia ||
              this.Request.AggregatorIdGeo == environment.request.idAmadeusColombia ||
              this.Request.AggregatorIdGeo == environment.request.idTravelPortColombia)
            {
              if(this.ContractTermsBool == false){
                this.approveTermsLegal.enable()
                this.SabreAmadeusBool = true
              }else{
                this.approveTermsLegal.disable()
                this.SabreAmadeusBool = true
              }
            }
            else{
              this.SabreAmadeusBool = false
              this.approveTermsLegal.disable()
            }

          if (this.Request.ConnectionTypeNavigation != undefined) {

            if (this.Request.ConnectionTypeNavigation.ContractTerms != undefined) {

              if ((this.Request.RequestStatus != undefined
                ? this.Request.RequestStatusNavigation.Description.toLowerCase()
                : "") == "contrato aceptado") {
                this.showButton = false
              }

              this.showButton = true


            } else {

              Swal.fire({
                icon: "error",
                title: this.translate.instant('AcceptTerms.Messages.2'),
                showConfirmButton: false,
                timer: 3000,
              });

              this.showButton = false
              this.SpinnerService.hide()
            }

          } else {

            Swal.fire({
              icon: "error",
              title: this.translate.instant('AcceptTerms.Messages.3'),
              showConfirmButton: false,
              timer: 3000,
            });

            this.showButton = false
            this.SpinnerService.hide()

          }

        });

    } else {

      Swal.fire({
        icon: "error",
        title: this.translate.instant('AcceptTerms.Messages.4'),
        showConfirmButton: false,
        timer: 3000,
      });

      this.showButton = false
      this.SpinnerService.hide()

      this.redirectContinue()

    }
  }

  SetCheck(valor){
    if(!valor)
    {
      this.checked = false
    }
    else
    {
      this.checked = true
    }

  }

  public async getValidateTermsAndConditions (RequestId){
    await this.DocumentService.getValidateTermsAndConditions(RequestId).then(resp => {
      this.ContractTermsBool = resp.Approved
      this.isRejected = resp.Rejected
      
      let today = new Date()
      let AnyoHoy = today.getFullYear();
      let MesHoy = today.getMonth();
      let DiaHoy = today.getDate();

      let rejectDate = new Date(resp.LastDate)
      let AnyoFecha = rejectDate.getFullYear();
      let MesFecha = rejectDate.getMonth();
      let DiaFecha = rejectDate.getDate();

      
      let todayCompare = new Date(AnyoHoy,MesHoy,DiaHoy)
      let rejectCompare = new Date(AnyoFecha,MesFecha,DiaFecha)
      rejectCompare.setDate(rejectCompare.getDate() + 30);
      
      if(resp.Approved != true && (todayCompare > rejectCompare) )
      {
        this.ContractTermsBool = true
      }
      
      if(this.ContractTermsBool == false){
        this.approveTermsLegal.disable()
      }
    })
  }

  redirectContinue() {

    setTimeout(() => {
      window.location.replace(`Register/`);
  }, 40000);  //5s
  }


  /**
   * AcceptContractTerms
   */
  public async AcceptContractTerms() {

    this.ContractTermsAgency = new ContractTermsAgencyModel()
    this.ContractTermsAgency.Id = 0
    this.ContractTermsAgency.IdRequest = this.Request.Id
    this.ContractTermsAgency.RequestCode = this.Request.RequestCode
    this.ContractTermsAgency.ContractUrl = this.Request.ConnectionTypeNavigation.ConnectionTypeContract[0].ContractUrl
    this.ContractTermsAgency.NameAprovate = this.approveTermsLegal.value
    this.ContractTermsAgency.Status = "Aproved"


    Swal.fire({
      title: this.translate.instant("AcceptTerms.Messages.SureAccept"),
      text: this.translate.instant("AcceptTerms.Messages.Inactivate"),
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: this.translate.instant("AcceptTerms.Messages.Cancel"),
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: this.translate.instant("AcceptTerms.Messages.Confirm"),
    }).then(async (result) => {

      if (result.value) {

        this.SpinnerService.show()

        await this.Service.postContractTermsAgency(this.ContractTermsAgency).then(
          async (res) => {

            this.ContractTermsAgency = res;
            await this.Service.AgencyContractAcept(this.Request).then(async (res) => {
              
              let StateChange = new StatusChangeByComponentView();

              StateChange.Approve = true;
              StateChange.IdRequest = this.Request.Id;
              StateChange.IdComponent = 19;

              /* Status Change */
             const resp = await this.RequesStatus.SetStatusByComponent(StateChange)

             if(resp.head.status.toLowerCase() != 'true'){
              await Swal.fire({
                title: 'Error!',
                text: this.translate.instant('Request.Messages.ErrorSaving'),
                icon: 'error'
              })
             }
            });

            Swal.fire({
              icon: "success",
              title: this.translate.instant('AcceptTerms.Messages.6'),
              showConfirmButton: false,
              timer: 3000,
            });

            this.showButton = false
            this.SpinnerService.hide()
            this.dataService.notifyAboutChange();

            this.openModalConsulData();
            this.getValidateTermsAndConditions(this.Request.Id);
          }
        );

      }

      this.GetRequestByCode();

    });

  }

  public async RejectContractTerms() {

    this.ContractTermsAgency = new ContractTermsAgencyModel()
    this.ContractTermsAgency.Id = 0
    this.ContractTermsAgency.IdRequest = this.Request.Id
    this.ContractTermsAgency.RequestCode = this.Request.RequestCode
    this.ContractTermsAgency.Status = "Rejected"

    Swal.fire({
      customClass: {title: 'h6'},
      title: '<h5>' + this.translate.instant("AcceptTerms.Messages.SureReject") + '</h5>',
      text: this.translate.instant("AcceptTerms.Messages.Inactivate"),
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: this.translate.instant("AcceptTerms.Messages.Cancel"),
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: this.translate.instant("AcceptTerms.Messages.Confirm"),
    }).then(async (result) => {

      if (result.value) {

        this.SpinnerService.show()

        await this.Service.postContractTermsAgency(this.ContractTermsAgency).then(
          async (res) => {

            this.ContractTermsAgency = res;
            await this.Service.AgencyContractReject(this.Request).then(async (res) => {

              this.lsService.removeLSItem('IdRequest')

              let StateChange = new StatusChangeByComponentView();

              StateChange.Approve = false;
              StateChange.IdRequest = this.Request.Id;
              StateChange.IdComponent = 19;

              const resp = await this.RequesStatus.SetStatusByComponent(StateChange)

             if(resp.head.status.toLowerCase() != 'true'){
              await Swal.fire({
                title: 'Error!',
                text: this.translate.instant('Request.Messages.ErrorSaving'),
                icon: 'error'
              })
             }
            });

            Swal.fire({
              icon: "warning",
              title: this.translate.instant('AcceptTerms.Messages.5'),
              showConfirmButton: false,
              timer: 3000,
            });

            this.showButton = false
            this.SpinnerService.hide()
            this.dataService.notifyAboutChange();

            this.openModalConsulData();
            this.getValidateTermsAndConditions(this.Request.Id);

          }
        );

      }

    });


  }

  async DocumentPrint() {
    let url: string
    await this.Service2.getUrlTyC(this.Request.Id).then(async (res) => {
      url = res;
    });
    if (url) {
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.download = 'ContractTerms.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      Swal.fire({
      icon: "error",
      title: this.translate.instant('AcceptTerms.Messages.ErrorDownloading'),
      showConfirmButton: false,
      timer: 3000,
      });
    }

  }
  openModalConsulData(){
    const modalRef = this.modalService.open(ConsultConnectionDataComponent, { size: 'lg' });
    modalRef.componentInstance.type = this.type;
  }

  public async getDocumentsApproval(RequestId) {
    await this.DocumentService.getDocumentsApproval(RequestId).then(resp => {
      this.AprovedFlowStateBool = resp.Approved
    })
  }

  get approveTermsLegal() { return this.form.get('approveTermsLegal'); }
  get approveTermsBool() { return this.form.get('approveTermsBool'); }

}
